import { useEffect, useMemo } from 'react';

import { useAppStore } from '@common/stores/useAppStore';
import { Result } from '@common/ui/Result';

import { useTaskLimits } from '@entities/tasks/hooks/useTaskLimits';

import { analytics } from '@services/AnalyticsService';

import { TaskListItem } from './components';

export const Tasks: React.FC = () => {
  const { tasks } = useAppStore();
  const { limitReached, getAvailableTasksWithinLimit } = useTaskLimits();

  useEffect(() => {
    if (tasks) {
      analytics.trackTaskListViewed();
    }
  }, [tasks]);

  const visibleTasks = useMemo(
    () => getAvailableTasksWithinLimit(tasks),
    [tasks, getAvailableTasksWithinLimit],
  );

  return (
    <>
      {limitReached && (
        <Result
          src={'/icons/3d-icons/not-found.png'}
          title="Достигнут дневной лимит заданий"
          description="Загляните завтра, чтобы получить новые задания"
          style={{ margin: 0 }}
        />
      )}

      {!limitReached &&
        visibleTasks?.map((task) => {
          const getTaskPosition = () => {
            const list = visibleTasks ?? [];
            const index = list.findIndex((item) => item.id === task.id);
            return index >= 0 ? index + 1 : undefined; // 1-based position
          };

          return (
            <TaskListItem
              key={task.id}
              task={task}
              taskPosition={getTaskPosition()}
            />
          );
        })}

      {!limitReached && visibleTasks?.length === 0 && (
        <Result
          src={'/icons/3d-icons/not-found.png'}
          title="Задания отсутствуют"
          description="Здесь будут отображаться задания, которые вы можете выполнить"
        />
      )}
    </>
  );
};

Tasks.displayName = 'Tasks';
